import React, { useState } from "react";

const RegisterForm = ({ onUserRegistered }) => {
  const [login, setLogin] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState(""); // По умолчанию "user"
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Список доступных ролей
  const roles = [
    { value: "user", label: "Отдел продаж" },
    { value: "service", label: "Сервис" },
    { value: "prefull", label: "Стоянка" },
    { value: "office-manager", label: "Отгрузка" },
    { value: "full", label: "Мастер приемщик" },
    { value: "admin", label: "Администратор" },
    
    
  ];

  const handleSubmit = async (e) => {
    e.preventDefault(); // Предотвращаем перезагрузку страницы

    // Простая валидация
    if (login.length < 3 || password.length < 6) {
      setError("Логин должен быть минимум 3 символа, пароль минимум 6.");
      return;
    }

    try {
      const response = await fetch("/api/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ login, password, role }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Ошибка регистрации");
      }

      setSuccess("Регистрация успешна!");
      setError(null);
      setLogin("");
      setPassword("");
      setRole("user"); // Сбрасываем выбор на "user"
      // Перезапрашиваем список пользователей
      if (onUserRegistered) {
        onUserRegistered();
      }
    } catch (err) {
      setError(err.message);
      setSuccess(null);
    }
  };

  return (
    <div style={styles.container}>
      <h2>Регистрация</h2>
      <form onSubmit={handleSubmit} style={styles.form} autoComplete="off">

        <label style={styles.label}>
          <input
            type="text"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            required
            autoComplete="off"
            placeholder="Введите логин.."
            style={styles.input}
          />
        </label>
        <label style={styles.label}>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Введите пароль"
            autoComplete="new-password"
            style={styles.input}
          />
        </label>
        <label style={styles.label}>
        <select
      value={role}
      onChange={(e) => setRole(e.target.value)}
      required
      style={styles.input}
    >
      <option value="" disabled>Выберите роль</option> {/* Добавляем плейсхолдер для select */}
      {roles.map((r) => (
        <option key={r.value} value={r.value}>
          {r.label}
        </option>
      ))}
    </select>
        </label>
        {error && <p style={styles.error}>{error}</p>}
        {success && <p style={styles.success}>{success}</p>}
        <button type="submit" style={styles.button_add_akk}>
          Создать аккаунт
        </button>
      </form>
    </div>
  );
};

const styles = {
  container: { maxWidth: "800px", padding: "20px", border: "1px solid gray",borderRadius: "9px", margin: "0 0 10px 0",display: "flex",
        justifyContent: "center", flexDirection: "column", alignItems: "center"},
  form: { display: "flex", flexDirection: "column", gap: "10px" },
  label: { fontWeight: "bold" },
  input: { padding: "8px", borderRadius: "5px", border: "1px solid #ccc" },
  button_add_akk: {
    padding: "10px",
    border: "none",
    borderRadius: "5px",
    background: "#007bff",
    color: "#fff",
    cursor: "pointer",
    width: "205px"
  },
  error: { color: "red", fontWeight: "bold" },
  success: { color: "green", fontWeight: "bold" },
};

export default RegisterForm;
